import { Alert } from 'antd';
import { useEffect, useRef, useState } from 'react';

export const useTour = (flag, isAdmin = false) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [allowNextStep, setAllowNextStep] = useState(false);

  const addUserRef = useRef(null);
  const editUserRef = useRef(null);

  useEffect(() => {
    setAllowNextStep(flag);
  }, [flag]);

  const steps = [
    {
      title: 'Страница пользователей',
      description:
        'Добро пожаловать в раздел «Пользователи» — здесь вы управляете доступами, редактируете данные и формируете круг доверия. Это ваш главный центр управления пользователями системы.',
      target: null,
    },
    {
      title: 'Добавление пользователя',
      description: 'Нажмите для регистрации нового пользователя.',
      target: () => addUserRef.current,
    },
    {
      title: 'Добавление пользователя',
      description: (
        <>
          <div>
            Заполните необходимые поля. При отсутствии выбранного ответственного, вы назначаетесь им автоматически. Для
            подтверждения нажмите ОК.
          </div>
          {!allowNextStep && (
            <Alert
              message={'Для продолжения просмотра инструкции зарегистрируйте нового пользователя.'}
              style={{ marginTop: '10px' }}
            />
          )}
        </>
      ),
      target: () => addUserRef.current,
    },
    {
      title: 'Таблица пользователей',
      description: 'В таблице отображаются все зарегистрированные пользователи с основными данными.',
      target: null,
    },
    {
      title: 'Изменение пользователя',
      description: isAdmin
        ? 'Нажмите для открытия панели управления пользователем — здесь вы редактируете данные, выдаёте доступ к разделам, формируете круг доверия и назначаете административные полномочия для чёткой и слаженной работы в контуре.'
        : 'Нажмите для открытия панели управления пользователем — здесь вы редактируете данные, выдаёте доступ к разделам и формируете круг доверия для чёткой и слаженной работы в контуре.',
      target: () => editUserRef.current,
    },
  ];

  const startTour = () => {
    setCurrentStep(0);
    setIsTourOpen(true);
  };

  const handleTourChange = nextStep => {
    if (nextStep === 3 && !allowNextStep) {
      return;
    }

    setCurrentStep(nextStep);
  };

  const handleClose = () => {
    setIsTourOpen(false);
  };

  return {
    isTourOpen,
    currentStep,
    handleClose,
    steps,
    startTour,
    handleTourChange,
    setAllowNextStep,
    addUserRef,
    editUserRef,
  };
};
